/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import logo from '../Recursos/logo_blanco.svg'
import {CONTACTOS, NEGRITA, OFERTAACADEMICA, REDES, SECCIONES} from "../Constantes";
import {useIrRuta} from "../Utilidades/useIrRuta";
import {useNavigate} from "react-router-dom";
import {scrolearAComponente} from "../Utilidades/scrolearAComponente";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politica from "./Dialogos/Dialogo_Politicas";
import {theme} from "../Tema";
import Dialogo_Formulario_Interactivo from "./Dialogos/Dialogo_Formulario_Interactivo";


const Footer = () => {
    const {sCell} = useResponsive()
    const {Dialogo: DialogoInter, abrir: abrirDialogo} = useDialogo({
        Componente: Dialogo_Formulario_Interactivo,
        titulo: 'Pre-Inscripcion'
    })
    const {ir} = useIrRuta({funcionUno: abrirDialogo})
    const navigate = useNavigate();
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politica})
    const [politicas, setPoliticas] = useState([]);

    const irLocal = (nom) => {

        navigate('/Locales')
        setTimeout(() => {
            scrolearAComponente(nom)
        }, 500)
    }

    useEffect(() => {


    }, [])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.primary.main,
                borderTop: 6,
                borderColor: theme.palette.info.main,

            }}
        >

            <Dialogo/>

            <DialogoInter/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 8, color: '#fff'}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 4}}

                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mb: 0, mt: 0}}>
                                <img src={logo} width={200} height={'auto'}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 4}}>
                                <Typography>Contenido aquí, contenido aquí". Estos textos hacen parecerlo un español
                                    que </Typography>
                            </Grid>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{mt: 2}}
                            >

                                {REDES.map((item) => {

                                    return (
                                        <IconButton>
                                            <img src={item.img} style={{width: 48, height: 48}}/>
                                        </IconButton>
                                    )

                                })}

                            </Grid>


                        </Grid>


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 8}}>


                            <Grid container size={{xs: 12, sm: 4, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{fontFamily: NEGRITA, fontSize: 26}}>Links Rápidos</Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 3}}>
                                        <Grid
                                            container
                                            justifyContent={'flex-start'}
                                            alignItems={'flex-start'}
                                            size={{xs: 12, sm: 12, md: 12}}
                                            spacing={1}
                                        >


                                            {SECCIONES.map((it) => (
                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'flex-start'}}>
                                                    <Typography
                                                        onClick={() => ir(it)}
                                                        sx={{
                                                            fontSize: 18,
                                                            cursor: 'pointer',
                                                            transition: 'all .2s ease-in-out',
                                                            borderBottom: 1,
                                                            borderColor: '#ffffff00',
                                                            '&:hover': {
                                                                borderColor: '#ffffff',
                                                            }

                                                        }}>{it}</Typography>
                                                </Grid>
                                            ))}

                                            {politicas.map((it) => (
                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'flex-start'}}>
                                                    <Typography
                                                        onClick={() => abrir(it)}
                                                        sx={{
                                                            fontSize: 16,
                                                            cursor: 'pointer',
                                                            transition: 'all .2s ease-in-out',
                                                            borderBottom: 1,
                                                            borderColor: '#ffffff00',
                                                            '&:hover': {
                                                                borderColor: '#ffffff',
                                                            }

                                                        }}>{it.titulo}</Typography>
                                                </Grid>
                                            ))}


                                        </Grid>

                                    </Grid>

                                </Grid>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 4, md: 4}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{fontFamily: NEGRITA, fontSize: 26}}>Contactos</Typography>
                                    </Grid>


                                    {CONTACTOS.map((it, index) => {


                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start', mt: 1}}>
                                                <Typography
                                                    // onClick={() => irLocal(it.nombre)}
                                                    sx={{
                                                        fontSize: 16,
                                                        fontWeight: 400,
                                                        cursor: 'pointer',
                                                        transition: 'all .2s ease-in-out',
                                                        borderBottom: 1,
                                                        borderColor: '#ffffff00',
                                                        "&:hover": {
                                                            borderColor: '#ffffff',
                                                        }
                                                    }}>

                                                    {it.nombre + ": " + it.descripcion}</Typography>
                                            </Grid>
                                        )


                                    })}


                                </Grid>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 4, md: 5}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0, pl: 1}}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{fontFamily: NEGRITA, fontSize: 26}}>
                                            OFERTA ACADEMICA
                                        </Typography>
                                    </Grid>


                                    {OFERTAACADEMICA.map((it, index) => {


                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start', mt: 1}}>
                                                <Typography
                                                    onClick={() => navigate('/Escuela/' + it.nombre)}
                                                    sx={{
                                                        fontSize: 16,
                                                        fontWeight: 400,
                                                        cursor: 'pointer',
                                                        transition: 'all .2s ease-in-out',
                                                        borderBottom: 1,
                                                        borderColor: '#ffffff00',
                                                        "&:hover": {
                                                            borderColor: '#ffffff',
                                                        }
                                                    }}>

                                                    {it.nombre}</Typography>
                                            </Grid>
                                        )


                                    })}


                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}}
                      sx={{justifyContent: 'center', borderTop: 1, mt: 8, pt: 3, borderColor: '#ffffff50'}}>
                    <Typography sx={{color: '#fff'}}>© Corporacion Cessa 2026 - 2027</Typography>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Footer